import { VuexModule, getModule, Mutation, Action } from 'vuex-module-decorators'
import DynamicModule from '@/decorators/DynamicModule'
import { NotifyHelper } from 'vue-kit'
import { Markup } from '@/dto/deliveries/Markup'
import MarkupService from '@/services/MarkupService'
import DeliveryStore from '@/stores/DeliveryStore'

@DynamicModule
class MarkupStore extends VuexModule {
  public markups: Markup[] = []

  @Mutation
  public setMarkups(markups: Markup[]) {
    this.markups = markups
  }

  @Mutation
  public updateInList(markup: Markup) {
    const index = this.markups.findIndex(m => m.project === markup.project)

    if (index !== -1) {
      this.markups.splice(index, 1, markup)
    }
  }

  @Action({ rawError: true })
  async save(model: Markup): Promise<Markup | void> {
    return MarkupService.save(model, DeliveryStore.deliveryId as number)
      .then((markup: Markup) => {
        NotifyHelper.success('Успешное сохранение')
        this.updateInList(markup)

        return markup
      })
      .catch(error => {
        if (!error.response.data.errors) {
          NotifyHelper.serverError()
        }
      })
  }

  @Action({ rawError: true })
  async load() {
    const markups = await MarkupService.load(DeliveryStore.deliveryId as number)
    this.setMarkups(markups)
  }
}

export default getModule(MarkupStore)
